import { type ApiSingleUseCardDetails } from 'modules/single-use-cards/models/ApiSingleUseCardDetails';
import { getV2ApiCompanyIdCardsSinglePurchaseRequestId } from 'src/client/spendesk-api';

export type GetSinglePurchaseCardDetailsInput = {
  companyId: string;
  requestId: string;
};

export const getSinglePurchaseCardDetails = async ({
  companyId,
  requestId,
}: GetSinglePurchaseCardDetailsInput): Promise<ApiSingleUseCardDetails> => {
  const response = await getV2ApiCompanyIdCardsSinglePurchaseRequestId({
    path: {
      companyId,
      requestId,
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to retrieve single-use card details.');
  }

  return response.body.data as ApiSingleUseCardDetails;
};
